export default "__VITE_ASSET__CCd5PG_7__"